import React, { useState, useEffect, useMemo, useContext } from 'react';
import {
  Widget,
  GridView,
  SimpleView,
  Table,
  Button,
  ButtonDelete,
  MasterDetailForm,
  FormInput,
  notification,
  FormTextArea,
  ColumnProps,
  Form,
  Row,
  Col,
  FormResetButton,
  CompositeView,
  CrudContext
} from '@digital/ui';
import { Collapse, Input, Tooltip, Icon, Card, Divider } from 'antd';
import { compareText } from '@app/helpers/comparators';
import { CrfCicloOrcamentarioProjetoDadosGerais, CrfCicloOrcamentarioProjetoPacote, getCicloOrcamentarioProjetoDadosGerais, CrfCicloOrcamentarioRelatorioResult } from '@app/api/crf/crfRelatorioCicloOrcamentario';
import AbaPacote from './AbaPacote';
import Grafico from './Graficos';
import RelatorioCicloOrcamentarioProjetoDadosGerais from './dadosGerias';

interface RelatorioCicloOrcamentarioProjetoProp {
  result: CrfCicloOrcamentarioRelatorioResult;
}

const CrfRelatorioCicloOrcamentarioProjeto = () => {
  const { Panel } = Collapse;
  const [cicloOrcamentarioProjetoDadosGerais, setCicloOrcamentarioProjetoDadosGerais] = useState<CrfCicloOrcamentarioProjetoDadosGerais>();
  const [cicloOrcamentarioProjetoPacote, setCicloOrcamentarioProjetoPacote] = useState<CrfCicloOrcamentarioProjetoPacote>();
  const [projetoId, setProjeto] = useState<string>();

  useEffect(() => {
    var projetoId = (new URLSearchParams(window.location.search)).get("projetoId");

    if (projetoId) {
      setProjeto(projetoId);
      getCicloOrcamentarioProjetoDadosGerais(projetoId).then((data) => {
        setCicloOrcamentarioProjetoDadosGerais(data);
      });
    }
  }, []);

  const collunsPacote = useMemo(() => {

    if (cicloOrcamentarioProjetoPacote) {

      const colluns: ColumnProps<any>[] = [
        {
          title: 'COD.PACOTE',
          dataIndex: 'codPacote',
          sorter: (a, b) => compareText(a.codPacote, b.codPacote),
          filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <Form>
              <Row>
                <FormInput
                  placeholder="Pesquisar COD.PACOTE"
                  name="codPacote"
                  style={{ marginTop: '15px' }}
                  onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                  onPressEnter={() => {
                    if (typeof confirm === 'function') confirm();
                  }}
                />
              </Row>
              <Row>
                <Col span={6}>
                  <Button
                    type="primary"
                    style={{ marginLeft: '5px' }}
                    onClick={() => {
                      if (typeof confirm === 'function') confirm();
                    }}
                    icon="commons-search"
                    size="small">
                    Pesquisar
                  </Button>
                </Col>
                <Col span={6}>
                  <FormResetButton
                    size="small"
                    style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                    beforeReset={() => {
                      if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                    }}>
                    Limpar
                  </FormResetButton>
                </Col>
              </Row>
            </Form>
          ),
          filterIcon: filtered => {
            const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
            return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
          },
          onFilter: (value, record) =>
            record.codPacote !== undefined &&
            record.codPacote
              .toString()
              .toLowerCase()
              .includes(value.toLowerCase()),
        },
        {
          title: 'Nome do Pacote',
          dataIndex: 'nomePacote',
          sorter: (a, b) => compareText(a.nomePacote, b.nomePacote),
          filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <Form>
              <Row>
                <FormInput
                  placeholder="Pesquisar COD.PACOTE"
                  name="nomePacote"
                  style={{ marginTop: '15px' }}
                  onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                  onPressEnter={() => {
                    if (typeof confirm === 'function') confirm();
                  }}
                />
              </Row>
              <Row>
                <Col span={6}>
                  <Button
                    type="primary"
                    style={{ marginLeft: '5px' }}
                    onClick={() => {
                      if (typeof confirm === 'function') confirm();
                    }}
                    icon="commons-search"
                    size="small">
                    Pesquisar
                  </Button>
                </Col>
                <Col span={6}>
                  <FormResetButton
                    size="small"
                    style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                    beforeReset={() => {
                      if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                    }}>
                    Limpar
                  </FormResetButton>
                </Col>
              </Row>
            </Form>
          ),
          filterIcon: filtered => {
            const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
            return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
          },
          onFilter: (value, record) =>
            record.nomePacote !== undefined &&
            record.nomePacote
              .toString()
              .toLowerCase()
              .includes(value.toLowerCase()),
        },
        {
          title: `${cicloOrcamentarioProjetoPacote.valorTotalA}`,
          align: 'center',
          children: [{
            title: 'A',
            align: 'center',
            children: [{
              title: 'Orçado Ano',
              dataIndex: 'orcadoAno',
              align: 'center',
              sorter: (a, b) => compareText(a.orcadoAno, b.orcadoAno),
              filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <Form>
                  <Row>
                    <FormInput
                      placeholder="Pesquisar COD.PACOTE"
                      name="orcadoAno"
                      style={{ marginTop: '15px' }}
                      onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                      onPressEnter={() => {
                        if (typeof confirm === 'function') confirm();
                      }}
                    />
                  </Row>
                  <Row>
                    <Col span={6}>
                      <Button
                        type="primary"
                        style={{ marginLeft: '5px' }}
                        onClick={() => {
                          if (typeof confirm === 'function') confirm();
                        }}
                        icon="commons-search"
                        size="small">
                        Pesquisar
                      </Button>
                    </Col>
                    <Col span={6}>
                      <FormResetButton
                        size="small"
                        style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                        beforeReset={() => {
                          if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                        }}>
                        Limpar
                      </FormResetButton>
                    </Col>
                  </Row>
                </Form>
              ),
              filterIcon: filtered => {
                const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
              },
              onFilter: (value, record) =>
                record.orcadoAno !== undefined &&
                record.orcadoAno
                  .toString()
                  .toLowerCase()
                  .includes(value.toLowerCase()),
            }]
          }]
        },
        {
          title: `${cicloOrcamentarioProjetoPacote.valorTotalB}`,
          align: 'center',
          children: [{
            title: 'B',
            align: 'center',
            children: [{
              title: 'Contratado',
              align: 'center',
              dataIndex: 'contratado',
              sorter: (a, b) => compareText(a.contratado, b.contratado),
              filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <Form>
                  <Row>
                    <FormInput
                      placeholder="Pesquisar COD.PACOTE"
                      name="contratado"
                      style={{ marginTop: '15px' }}
                      onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                      onPressEnter={() => {
                        if (typeof confirm === 'function') confirm();
                      }}
                    />
                  </Row>
                  <Row>
                    <Col span={6}>
                      <Button
                        type="primary"
                        style={{ marginLeft: '5px' }}
                        onClick={() => {
                          if (typeof confirm === 'function') confirm();
                        }}
                        icon="commons-search"
                        size="small">
                        Pesquisar
                      </Button>
                    </Col>
                    <Col span={6}>
                      <FormResetButton
                        size="small"
                        style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                        beforeReset={() => {
                          if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                        }}>
                        Limpar
                      </FormResetButton>
                    </Col>
                  </Row>
                </Form>
              ),
              filterIcon: filtered => {
                const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
              },
              onFilter: (value, record) =>
                record.contratado !== undefined &&
                record.contratado
                  .toString()
                  .toLowerCase()
                  .includes(value.toLowerCase()),
            }]
          }]
        },
        {
          title: `${cicloOrcamentarioProjetoPacote.valorTotalC}`,
          align: 'center',
          children: [{
            title: 'C',
            align: 'center',
            children: [{
              title: 'Executado',
              align: 'center',
              dataIndex: 'executado',
              sorter: (a, b) => compareText(a.executado, b.executado),
              filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <Form>
                  <Row>
                    <FormInput
                      placeholder="Pesquisar"
                      name="executado"
                      style={{ marginTop: '15px' }}
                      onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                      onPressEnter={() => {
                        if (typeof confirm === 'function') confirm();
                      }}
                    />
                  </Row>
                  <Row>
                    <Col span={6}>
                      <Button
                        type="primary"
                        style={{ marginLeft: '5px' }}
                        onClick={() => {
                          if (typeof confirm === 'function') confirm();
                        }}
                        icon="commons-search"
                        size="small">
                        Pesquisar
                      </Button>
                    </Col>
                    <Col span={6}>
                      <FormResetButton
                        size="small"
                        style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                        beforeReset={() => {
                          if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                        }}>
                        Limpar
                      </FormResetButton>
                    </Col>
                  </Row>
                </Form>
              ),
              filterIcon: filtered => {
                const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
              },
              onFilter: (value, record) =>
                record.executado !== undefined &&
                record.executado
                  .toString()
                  .toLowerCase()
                  .includes(value.toLowerCase()),
            }]
          }]
        },
        {
          title: `${cicloOrcamentarioProjetoPacote.valorTotalD}`,
          align: 'center',
          children: [{
            title: 'D',
            align: 'center',
            children: [{
              title: 'Requisitado',
              align: 'center',
              dataIndex: 'requisitado',
              sorter: (a, b) => compareText(a.requisitado, b.requisitado),
              filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <Form>
                  <Row>
                    <FormInput
                      placeholder="Pesquisar COD.PACOTE"
                      name="requisitado"
                      style={{ marginTop: '15px' }}
                      onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                      onPressEnter={() => {
                        if (typeof confirm === 'function') confirm();
                      }}
                    />
                  </Row>
                  <Row>
                    <Col span={6}>
                      <Button
                        type="primary"
                        style={{ marginLeft: '5px' }}
                        onClick={() => {
                          if (typeof confirm === 'function') confirm();
                        }}
                        icon="commons-search"
                        size="small">
                        Pesquisar
                      </Button>
                    </Col>
                    <Col span={6}>
                      <FormResetButton
                        size="small"
                        style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                        beforeReset={() => {
                          if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                        }}>
                        Limpar
                      </FormResetButton>
                    </Col>
                  </Row>
                </Form>
              ),
              filterIcon: filtered => {
                const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
              },
              onFilter: (value, record) =>
                record.requisitado !== undefined &&
                record.requisitado
                  .toString()
                  .toLowerCase()
                  .includes(value.toLowerCase()),
            }]
          }]
        },
        {
          title: `${cicloOrcamentarioProjetoPacote.valorTotalE}`,
          align: 'center',
          children: [{
            title: 'E = B - C + D',
            align: 'center',
            children: [{
              title: 'Compromissado',
              align: 'center',
              dataIndex: 'compromissado',
              sorter: (a, b) => compareText(a.compromissado, b.compromissado),
              filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <Form>
                  <Row>
                    <FormInput
                      placeholder="Pesquisar"
                      name="compromissado"
                      style={{ marginTop: '15px' }}
                      onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                      onPressEnter={() => {
                        if (typeof confirm === 'function') confirm();
                      }}
                    />
                  </Row>
                  <Row>
                    <Col span={6}>
                      <Button
                        type="primary"
                        style={{ marginLeft: '5px' }}
                        onClick={() => {
                          if (typeof confirm === 'function') confirm();
                        }}
                        icon="commons-search"
                        size="small">
                        Pesquisar
                      </Button>
                    </Col>
                    <Col span={6}>
                      <FormResetButton
                        size="small"
                        style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                        beforeReset={() => {
                          if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                        }}>
                        Limpar
                      </FormResetButton>
                    </Col>
                  </Row>
                </Form>
              ),
              filterIcon: filtered => {
                const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
              },
              onFilter: (value, record) =>
                record.compromissado !== undefined &&
                record.compromissado
                  .toString()
                  .toLowerCase()
                  .includes(value.toLowerCase()),
            }]
          }]
        },
        {
          title: `${cicloOrcamentarioProjetoPacote.valorTotalF}`,
          align: 'center',
          children: [{
            title: 'F',
            align: 'center',
            children: [{
              title: 'A Contratar',
              align: 'center',
              dataIndex: 'aContratar',
              sorter: (a, b) => compareText(a.aContratar, b.aContratar),
              filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <Form>
                  <Row>
                    <FormInput
                      placeholder="Pesquisar"
                      name="aContratar"
                      style={{ marginTop: '15px' }}
                      onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                      onPressEnter={() => {
                        if (typeof confirm === 'function') confirm();
                      }}
                    />
                  </Row>
                  <Row>
                    <Col span={6}>
                      <Button
                        type="primary"
                        style={{ marginLeft: '5px' }}
                        onClick={() => {
                          if (typeof confirm === 'function') confirm();
                        }}
                        icon="commons-search"
                        size="small">
                        Pesquisar
                      </Button>
                    </Col>
                    <Col span={6}>
                      <FormResetButton
                        size="small"
                        style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                        beforeReset={() => {
                          if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                        }}>
                        Limpar
                      </FormResetButton>
                    </Col>
                  </Row>
                </Form>
              ),
              filterIcon: filtered => {
                const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
              },
              onFilter: (value, record) =>
                record.aContratar !== undefined &&
                record.aContratar
                  .toString()
                  .toLowerCase()
                  .includes(value.toLowerCase()),
            }]
          }]
        },
        {
          title: `${cicloOrcamentarioProjetoPacote.valorTotalG}`,
          align: 'center',
          children: [{
            title: 'G = B + D + F',
            align: 'center',
            children: [{
              title: 'FORECAST',
              align: 'center',
              dataIndex: 'forecast',
              sorter: (a, b) => compareText(a.forecast, b.forecast),
              filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <Form>
                  <Row>
                    <FormInput
                      placeholder="Pesquisar"
                      name="forecast"
                      style={{ marginTop: '15px' }}
                      onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                      onPressEnter={() => {
                        if (typeof confirm === 'function') confirm();
                      }}
                    />
                  </Row>
                  <Row>
                    <Col span={6}>
                      <Button
                        type="primary"
                        style={{ marginLeft: '5px' }}
                        onClick={() => {
                          if (typeof confirm === 'function') confirm();
                        }}
                        icon="commons-search"
                        size="small">
                        Pesquisar
                      </Button>
                    </Col>
                    <Col span={6}>
                      <FormResetButton
                        size="small"
                        style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                        beforeReset={() => {
                          if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                        }}>
                        Limpar
                      </FormResetButton>
                    </Col>
                  </Row>
                </Form>
              ),
              filterIcon: filtered => {
                const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
              },
              onFilter: (value, record) =>
                record.forecast !== undefined &&
                record.forecast
                  .toString()
                  .toLowerCase()
                  .includes(value.toLowerCase()),
            }]
          }]
        },
        {
          title: `${cicloOrcamentarioProjetoPacote.valorTotalH}`,
          align: 'center',
          children: [{
            title: 'H = A - G',
            align: 'center',
            children: [{
              title: 'Saldo',
              align: 'center',
              dataIndex: 'saldo',
              sorter: (a, b) => compareText(a.saldo, b.saldo),
              filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <Form>
                  <Row>
                    <FormInput
                      placeholder="Pesquisar"
                      name="saldo"
                      style={{ marginTop: '15px' }}
                      onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                      onPressEnter={() => {
                        if (typeof confirm === 'function') confirm();
                      }}
                    />
                  </Row>
                  <Row>
                    <Col span={6}>
                      <Button
                        type="primary"
                        style={{ marginLeft: '5px' }}
                        onClick={() => {
                          if (typeof confirm === 'function') confirm();
                        }}
                        icon="commons-search"
                        size="small">
                        Pesquisar
                      </Button>
                    </Col>
                    <Col span={6}>
                      <FormResetButton
                        size="small"
                        style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                        beforeReset={() => {
                          if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                        }}>
                        Limpar
                      </FormResetButton>
                    </Col>
                  </Row>
                </Form>
              ),
              filterIcon: filtered => {
                const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
              },
              onFilter: (value, record) =>
                record.saldo !== undefined &&
                record.saldo
                  .toString()
                  .toLowerCase()
                  .includes(value.toLowerCase()),
            }]
          }]
        },
      ];
      return colluns;
    }
    return [];
  }, [cicloOrcamentarioProjetoPacote]);

  return (
    <SimpleView>
      <CrudContext.Consumer>
        {() => (
          <CompositeView>
            {true && cicloOrcamentarioProjetoDadosGerais ? (
              <GridView icon="commons-document" id="dadosgerais" noform title="DADOS GERAIS">
                <RelatorioCicloOrcamentarioProjetoDadosGerais
                  cicloOrcamentarioProjetoDadosGerais={cicloOrcamentarioProjetoDadosGerais}
                />
              </GridView>
            ) : (
              () => { }
            )}

            {projetoId ? (
              <GridView icon="commons-document" id={`pacote`} noform title="Pacote">
                <AbaPacote projetoId={projetoId} pageSize={20} />
              </GridView>
            ) : (
              () => { }
            )}

            {projetoId ? (
              <GridView icon="commons-document" id="cursoEconomica" noform title="Curva Econômica">
                <Grafico projetoId={projetoId} />
              </GridView>
            ) : (
              () => { }
            )}
          </CompositeView>
        )}
      </CrudContext.Consumer>
    </SimpleView>
  );
};

export default CrfRelatorioCicloOrcamentarioProjeto;
